const linksEn = [
	{
		path: '/en/academic/',
		home: true,
	},
	{
		path: '/en/academic/academic-centres/',
		name: 'Centers of Research & Expertise',
		active: true,
	},
	{
		path: '/en/academic/academic-faculty/',
		name: 'Professors',
		active: true,
	},
	{
		path: '/en/academic/academic-library/',
		name: 'Library',
		active: true,
	},
	{
		path: '/en/academic/academic-team/',
		name: 'Team',
		active: true,
	},
];

export default linksEn;
